<table
  *ngIf="isLoading || strategies?.length; else emptyListTemplate"
  class="ui segment strategies-table box-shadow-new"
>
  <tbody>
    <ng-container *ngIf="!isLoading; else skeletonTemplate">
      <tr
        *ngFor="let strategy of strategies"
        uiLogEvent
        [analyticsEventVersion]="2"
        analyticsKey="Price Strategy Edited"
        (click)="navigateToStrategy(strategy.id)"
      >
        <td class="strategy-name-column">
          <div class="bold">{{ strategy.name }}</div>
          <div class="sub-info">
            {{ 'txt_price_strategy_condition_' + strategy.condition | translate }}
          </div>
        </td>
        <td class="applied-to-column">
          <div>
            <div data-lokalise data-key="txt_pn_strategies_th_applied_to"></div>
          </div>
          <div class="sub-info">{{ strategy.numberOfAssignedProducts || 0 }} {{ 'txt_products' | translate }}</div>
        </td>
        <td class="last-updated-column">
          <div data-lokalise data-key="txt_pn_strategies_th_last_price"></div>
          <div class="sub-info">
            {{ strategy.publishedAt?.date ? (strategy.publishedAt.date | date: dateFormat) : datePlaceholder }}
          </div>
        </td>
        <td class="status-column">
          <div class="strategy-status" [ngClass]="strategy.status">{{ strategy.status | titlecase }}</div>
        </td>
        <td class="action-column" *ngIf="availableStrategyActions?.length">
          <gd-dropdown-menu [positionLeft]="true">
            <ng-container *ngFor="let action of availableStrategyActions">
              <div
                class="item"
                *ngIf="!action.condition || action.condition(strategy)"
                uiLogEvent
                [analyticsEventVersion]="2"
                [analyticsKey]="action.analyticsKey"
                [ngClass]="action.getCssClasses ? action.getCssClasses(strategy) : null"
                (click)="action.handler(strategy)"
              >
                {{ action.displayName | translate }}
              </div>
            </ng-container>
          </gd-dropdown-menu>
        </td>
      </tr>
    </ng-container>
  </tbody>
</table>

<ng-template #skeletonTemplate>
  <tr *ngFor="let _ of loaderRowsArray">
    <td
      *ngFor="
        let columnClass of [
          'strategy-name-column',
          'applied-to-column',
          'last-updated-column',
          'status-column',
          'action-column'
        ]
      "
      [class]="columnClass"
    >
      <ngx-skeleton-loader count="1"></ngx-skeleton-loader>
    </td>
  </tr>
</ng-template>

<ng-template #emptyListTemplate>
  <gd-price-navigator-empty-list [emptyListReasons]="emptyListReasons"> </gd-price-navigator-empty-list>
</ng-template>
